/**
 * @file 接口封装服务
 */
import config from "./config";
import axios from "axios";
import errorWarning from "./errorWarning";

export const fetch = axios.create(config.phpConfig); // 创建axios实例

fetch.interceptors.request.use(
    config => {
        // 请求拦截器
        let params = config.params || {};
        config.params = params;
        return config; // config为发送请求前做某事
    },
    error => Promise.reject(error)
); // 请求错误时做某事

// 返回状态判断
fetch.interceptors.response.use(
    res => {
        // 响应拦截器
        return errorWarning(res);
    },
    error => Promise.reject(error)
);